<template>
  <config-base class="opc-lm" ref="baseRef">
    <template #config>
      <capacity-config-list :config-plan-type="planType" :config-capacity-key="capacityKey" :capacity-unit-i18n-key="capacityUnitI18nKey" :show-monthly-price-from-cycle="true"></capacity-config-list>
      <preview-payment class="opc-lm__preview-payment" />
    </template>
  </config-base>
</template>

<script>
import {get, map} from "lodash";
import {mapGetters} from "vuex";
import planCommon from '@/plans/LARGE_MEETING/mixin';
import {getPlanTotalLicense} from "@/common/service/validate";
import {getNeedFilterCapacityList} from '@/common/product';
import {computedLargeMeetingPlans} from "@/common/service/computers/plans/large-meeting";
import plansMixin from "@/plans/mx/plan";
import ConfigList from "@/components/capacity/config-list.vue";
import ConfigBase from "@/plans/LARGE_MEETING/config/base.vue";
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import baseplanFreeToPaidReplenishMixin, { FreeTrialAutoAdd } from "@/components/capacity/mx/freetrial-baseplan-replenish";
import autoAddMixin from "@/common/mixin/autoAdd";
import autoAddCapacityMixin from '@/plans/LARGE_MEETING/mixins/auto-add-capacity';

const CapacityConfigList = {
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [planCommon, FreeTrialAutoAdd, autoAddMixin, autoAddCapacityMixin],
  data() {
    return {
      currentCapacityLicense: new Map(),
    }
  },
  computed: {
    ...mapGetters(['getCurrentMeetingPlans', 'getCurrentBasePlanInfo', 'boughtPlans', 'hasBoughtDependPlan', 'isProFreeTrialAddAddonCase']),
    boughtCurrentPlans() {
      return computedLargeMeetingPlans(this.boughtPlans)
    },
    planList() {
      return this.planMapFlat.filter((p) => {
        const isCurrentPlanType = p.type === this.planType;
        const isSupportCapacity = this.supportCapacity.includes(p[this.capacityKey]);
        const isBoughtCapacity = map(this.boughtCurrentPlans, this.capacityKey).includes(p[this.capacityKey]);
        const needFilterCapacity = getNeedFilterCapacityList(this.getCurrentBasePlanInfo?.plans).includes(p[this.capacityKey])
        return isCurrentPlanType && isSupportCapacity && !needFilterCapacity && !isBoughtCapacity;
      });
    },
    mx_licenseTips() {
      return this.totalLimitDesc;
    },
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    editTotalLimitDesc() {
      const basePlanNameKey = get(this.currentBasePlans, [0, 'parentPlanNameKey']) || get(this.currentBasePlans, [0, 'planNameKey']) || get(this.currentBasePlans, [0, 'typeNameKey'])
      return this.$t(
        (this.hasBoughtDependPlan && !this.isProFreeTrialAddAddonCase) ?
        'billing.addon_license_limit_tips' :
        'billing.addon_license_limit_tips_without_contact',
        [this.title, this.$t(basePlanNameKey)])
    },
    addAnotherCapacityCta() {
      return this.$t('billing.addAnother.large');
    },
  },
  methods: {
    syncAutoAddBasePlanLicense(capacity) {
      if (this.mx_canAutoAdd) {
        const maxLicense = Math.max(...this.currentCapacityLicense.values());
        this.mx_handleConfigRowLicenseChange(maxLicense, { capacity }).catch((previousLicense) => {
          this.currentCapacityLicense.set(capacity, previousLicense);
        });
      }
    },

    handleLicenseChange(license, oldLicense, { capacity }) {
      const condition = license >= this.mx_getMaxHosts() && this.mx_getMaxHosts() !== 999;
      // Vue3 Fix: Direct assignment works with reactive objects
      this.mx_license_capacityAlertMap[capacity] = condition ? this.editTotalLimitDesc : "";
      if (this.isProFreeTrialAddAddonCase) {
        this.mx_syncBasePlanLicenseForProFreeTrialAddonCase(license);
      }

      this.currentCapacityLicense.set(capacity, license);
      this.syncAutoAddBasePlanLicense(capacity);
    },
    mx_getMaxHosts() {
      if (this.isProFreeTrialAddAddonCase) {
        return 999
      }
      if (this.mx_canAutoAdd) {
        return this.mx_maxAutoAddLicense;
      }
      return getPlanTotalLicense(this.currentBasePlans || []) || 999;
    },
    mx_getDeleteVisible(capacity){
      return !(
        this.selectedPlanList?.length === 1
        && capacity === this.selectedPlanList?.[0].capacity)
    },
    afterAddCapacityHook(capacity) {
      this.currentCapacityLicense.set(capacity, 1);
    },
    /**
     * after delete capacity, update license Map
     * @param {object} planInfo deleted plan
     * @param {number} planInfo.capacity deleted plan capacity
     */
    afterDeleteCapacityHook({ capacity }) {
      this.currentCapacityLicense.delete(capacity);
      this.syncAutoAddBasePlanLicense(capacity);
    },
    afterSwitchCapacityHook(oldPlan, newPlan) {
      const oldCapacityLicense = this.currentCapacityLicense.get(oldPlan.capacity);
      this.currentCapacityLicense.delete(oldPlan.capacity);
      this.currentCapacityLicense.set(newPlan.capacity, oldCapacityLicense);
    },
  },
  mounted() {
    // init number of config row license
    this.visibleCapacityList.forEach((capacity) => {
      const license = get(
        this.mx_getPlanInfoByCapacity(capacity),
        'cartInfo.selected_number',
      );
      if (license) {
        this.currentCapacityLicense.set(capacity, license);
      }
    });
  }
}
export default {
  mixins: [baseplanFreeToPaidReplenishMixin, plansMixin, planCommon],
  components: { PreviewPayment, ConfigBase, CapacityConfigList }
};
</script>

<style lang="scss">
.opc-lm {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
